/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { QueryCostDataResponseRecordsInner } from '../models/QueryCostDataResponseRecordsInner';

export class QueryCostDataResponse {
  /**
  * Array of cost records based on requested filters and grouping
  */
  'records': Array<QueryCostDataResponseRecordsInner>;
  /**
  * Total number of records available
  */
  'totalCount': number;
  /**
  * Total number of unique resources in time range
  */
  'totalUniqueResources': number;
  /**
  * Number of unique resources after applying filters in time range
  */
  'filteredUniqueResources': number;
  /**
  * Token for retrieving next page of results
  */
  'nextToken'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "records",
      "baseName": "records",
      "type": "Array<QueryCostDataResponseRecordsInner>",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "totalUniqueResources",
      "baseName": "totalUniqueResources",
      "type": "number",
      "format": ""
    },
    {
      "name": "filteredUniqueResources",
      "baseName": "filteredUniqueResources",
      "type": "number",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return QueryCostDataResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

